import { useId } from 'react';
import { Link } from 'react-router-dom';
import './ConsentCheckbox.css';

interface Props {
  readonly checked: boolean;
  readonly onChange: (v: boolean) => void;
  readonly label: string;
  readonly docPath: string;
  readonly disabled?: boolean;
}

export default function ConsentCheckbox({
  checked,
  onChange,
  label,
  docPath,
  disabled,
}: Props) {
  const id = useId();
  return (
    <div className="om-consent">
      <input
        id={id}
        type="checkbox"
        className="om-consent__input"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <label htmlFor={id} className="om-consent__label">
        I agree to the {label}
      </label>
      <Link to={docPath} className="om-consent__view" target="_blank" rel="noopener">
        view
      </Link>
    </div>
  );
}
